import { handleActions } from 'redux-actions';
import { logoutSuccess } from 'ducks/auth/actions';

import { activeIRsGroupedByTypeSuccess } from './actions';

import initialState from './states';

export default handleActions(
  {
    [activeIRsGroupedByTypeSuccess](state, { payload }) {
      return {
        ...state,
        activeIRsGroupedByType: payload,
      };
    },
    [logoutSuccess]() {
      return initialState;
    },
  },
  initialState
);
